// @ts-nocheck
import React from 'react';
import { createBrowserRouter, Navigate, useParams, Outlet } from 'react-router-dom';
import App from '../containers/App';
import OrganizationLayout from "../containers/OrganizationAdmin/OrganizationLayout";
import ResourceOrgGuard from '../components/AccessGuard/ResourceOrgGuard';
import BaseLayout from '../containers/BaseLayout';
// import HomePage from "@containers/HomePage";
const HomePage = React.lazy(() => import('../containers/HomePage'));
const LoginPage = React.lazy(() => import('../containers/LoginPage'));
import CreateOrganizationLayout from '../containers/CreateOrganization/CreateOrganizationLayout';
import LegacyWizardRedirect from '../containers/RegistrationAdmin/LegacyWizardRedirect';
// const CreateOrganizationLayout = React.lazy(() => import('../containers/CreateOrganization/CreateOrganizationLayout'));
const CreateLeague = React.lazy(() => import('../containers/OrganizationAdmin/CreateOrganization'));
import SignInPage from '../containers/SignInPage';
import ForgotPasswordPage from '../containers/ForgotPasswordPage';
import ResetPasswordPage from '../containers/ResetPasswordPage';
// import SignInPage from '@containers/SignInPage';
import SignUpPage from '../containers/SignUpPage';
import TermsPage from '../containers/TermsPage';
import PrivacyPage from '../containers/PrivacyPage';
import CreateLeaguePage from '../containers/CreateOrganization/CreateOrganizationPage';
import CreateConfirmStructurePage from '../containers/CreateOrganization/CreateConfirmStructurePage';
import CreateContestTypePage from '../containers/CreateOrganization/CreateContestTypePage';
const CreateRegistrationPage = React.lazy(() => import('../containers/CreateOrganization/CreateRegistrationPage'));
const CreateDonePage = React.lazy(() => import('../containers/CreateOrganization/CreateDonePage'));
const CreateAddTeamsPage = React.lazy(() => import('../containers/CreateOrganization/CreateAddTeamsPage'));
// Step 3 "Your divisions" (owner 2026-10-22): the built competition's tree,
// editable, between the organization step and Who's playing?. Also serves the
// teams step's Edit divisions round-trip (`?from=teams`); replaces the
// 2026-10-16 `?edit=1` mode of step 2.
const CreateDivisionsPage = React.lazy(() => import('../containers/CreateOrganization/CreateDivisionsPage'));
import CreateTournamentRegistrationPage from '../containers/CreateOrganization/CreateTournamentRegistrationPage';
// NOTE: there used to be a second, eager `import CreateLeagueRegistrationPage from
// '.../CreateOrganizationRegistrationPage'` here as well as the lazy const below.
// Two live declarations of one identifier is a TS2440 that only `// @ts-nocheck`
// at the top of this file was hiding; the bundler silently kept the const and
// discarded the import, so which component these routes rendered was decided by
// bundler tolerance rather than by the code. Removed the dead import — this keeps
// the behaviour that was actually shipping. See ADM-09-33.
const CreateLeagueRegistrationPage = React.lazy(() => import('../containers/CreateOrganization/CreateLeagueRegistrationPage'));
import OrganizeAdmin from '../containers/OrganizeAdmin/OrganizeAdmin';
import UpcomingGamesAdmin from '@/containers/UpcomingGamesAdmin/UpcomingGamesAdmin';
import StatAdmin from '@/containers/StatAdmin/StatAdmin';
import MemberAdmin from '@/containers/MemberAdmin/MemberAdmin';
import LocationAdmin from '@/containers/LocationAdmin/LocationAdmin';
import RegistrationListAdmin from '../containers/RegistrationAdmin/RegistrationListAdmin';
import RegistrationAdmin from '../containers/RegistrationAdmin/RegistrationAdmin';
import RegistrationEditPage from '../containers/RegistrationAdmin/RegistrationEditPage';
import RegistrationTeamAdmin from '../containers/RegistrationTeamAdmin/RegistrationTeamAdmin';
import SettingAdmin from '../containers/SettingAdmin/SettingAdmin';
import AppearanceAdmin from '../containers/AppearanceAdmin/AppearanceAdmin';
import DashboardAdmin from '../containers/DashboardAdmin/DashboardAdmin';
import GetStartedAdmin from '@/containers/GetStartedAdmin/GetStartedAdmin';
// Canvas Site Editor (ADR 0033) — replaced HomeEditorAdmin's editor-beside-preview layout.
import CanvasEditorAdmin from '../containers/EditorAdmin/canvas/CanvasEditorAdmin';
import WaiverAdmin from '../containers/WaiverAdmin/WaiverAdmin';
import TransactionAdmin from '../containers/TransactionAdmin/TransactionAdmin';
import DivisionSchedule from '../containers/DivisionAdmin/DivisionSchedule';
// const SetupPage = React.lazy(() => import('../containers/SetupPage'));
// DeterminePage retired: post-Clerk, SignInPage routes straight to /admin/dashboard
// or /setup based on the admin's organizations — no interstitial resolver needed.
import SetupPage from '@/containers/SetupPage';
import SetupPageNew from '@/containers/SetupPageNew';
import ProtectedRoute from '@/containers/ProtectedRoute';
import CreateApp from '@/containers/CreateApp';
import LogsAdmin from '@/containers/LogsAdmin/LogsAdmin';
import EmailTemplateAdmin from '@/containers/EmailTemplateAdmin/EmailTemplateAdmin';
import EmailTemplateEditor from '@/containers/EmailTemplateAdmin/EmailTemplateEditor';
// Broadcast messages (ADR 0053) — one-off emails to segments of the org.
import BroadcastAdmin from '@/containers/BroadcastAdmin/BroadcastAdmin';
import BroadcastCompose from '@/containers/BroadcastAdmin/BroadcastCompose';
import SchedulerAdmin from '@/containers/SchedulerAdmin/SchedulerAdmin.tsx';
import SchedulerListAdmin from '@/containers/SchedulerListAdmin/SchedulerListAdmin';
import TournamentSchedulerDay2Admin from '@/containers/TournamentSchedulerAdmin/TournamentSchedulerDay2Admin.tsx';
import TournamentBulkImportGames from '@/containers/TournamentSchedulerAdmin/TournamentBulkImportGames.tsx';
import DivisionPage from '@/containers/DivisionPage/DivisionPage';
import TeamDetailPage from '@/containers/TeamDetailPage/TeamDetailPage';
import ReplayWebhooks from '@/containers/StripeReplay/ReplayWebhooks';
// INTERNAL/UNLISTED support tool — reachable by URL only. Do NOT add to Nav.tsx or docs.
import ImpersonateAdmin from '@/containers/Impersonate/ImpersonatePage';
// Hidden owner-only usage analytics — deliberately absent from navItems + docs.
// Eager import like the other hidden /admin pages (that branch has no Suspense).
import AdminUsageAdmin from '@/containers/AdminUsageAdmin/AdminUsageAdmin';

import RouteErrorPage from '@/components/ErrorPage/RouteErrorPage';

const RedirectLeagueRoute = () => {
  const { seasonId: leagueId, '*': rest } = useParams();
  return <Navigate to={`/admin/organization/league/${leagueId}/${rest || ''}`} replace />;
};

const RedirectTournamentRoute = () => {
  const { tournamentId, seasonId: leagueId, '*': rest } = useParams();
  return <Navigate to={`/admin/organization/tournament/${tournamentId}/contest/${leagueId}/${rest || ''}`} replace />;
};

const RedirectSchedulerRoute = () => {
  const { seasonId: leagueId } = useParams();
  return <Navigate to={`/admin/organization/scheduler/${leagueId}`} replace />;
};

// One pathless root route so RouteErrorPage catches every routing error —
// 404s (no match) and render/loader crashes — instead of react-router's raw
// developer error page. Its element is the app-wide <Suspense> boundary the
// React.lazy routes below never had: without it, a cold navigation to a lazy
// route crashed with "A component suspended while responding to synchronous
// input" straight onto the raw error page. The fallback is a calm brand-ground
// blank — each page's own skeleton takes over as soon as it mounts.
const routes = createBrowserRouter([
  {
  errorElement: <RouteErrorPage />,
  element: (
    <React.Suspense fallback={<div className="min-h-screen bg-background" />}>
      <Outlet />
    </React.Suspense>
  ),
  children: [
  { path: '/home', element: <HomePage /> },
  // { path: "/sign-in", element: <SignInPage /> }, // avoid adding exact: true here, otherwise it will not match /sign-in/factor-one
  {
    path: "/sign-in/*",
    element: <SignInPage />,
  }, // avoid adding exact: true here, otherwise it will not match /sign-in/factor-one
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  { path: "/", element: <Navigate to="/admin/dashboard" replace /> },
    
  { path: "/sign-up/*", element: <SignUpPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  // { path: "/create-league", element: <CreateLeague />, exact: true },
  // { path: "/create-app", element: <CreateApp />, exact: true },
  { path: "/setup", element: <ProtectedRoute><SetupPageNew /></ProtectedRoute>, exact: true },
  {
    path: "/",
    element: <BaseLayout />,
    children: [
      // /editor moved into the admin shell (owner 2026-09-11: same header as
      // the other rail pages) — canonical URL is /admin/editor; this redirect
      // keeps old links/bookmarks working.
      { path: "/editor", element: <Navigate to="/admin/editor" replace />, exact: true },
    ]
  },
  {
    path: "/create",
    element: <CreateOrganizationLayout />,
    children: [
      {
        path: "/create/select-contest",
        element: <CreateContestTypePage />,
      },
      {
        path: "/create/create-organization",
        element: <CreateLeaguePage />,
      },
      {
        path: "/create/divisions",
        element: <CreateDivisionsPage />,
      },
      {
        // INT-0011 tier 2 — carried-teaser signups only (step 3 of 4).
        path: "/create/confirm-structure",
        element: <CreateConfirmStructurePage />,
      },
      {
        // INT-0043: "Who's playing?" — paste teams per division + first game
        // date (or bring a schedule, INT-0051), after the divisions step.
        path: "/create/add-teams",
        element: <CreateAddTeamsPage />,
      },
      {
        // INT-0028: the wizard's finish line — one shareable artifact.
        path: "/create/done",
        element: <CreateDonePage />,
      },
      {
        path: "/create/create-registration",
        element: <CreateRegistrationPage />,
      },
      {
        path: "/create/create-league-registration",
        element: <CreateLeagueRegistrationPage />,
      },
      {
        path: "/create/create-tournament-registration",
        element: <CreateTournamentRegistrationPage />,
      },
      {
        path: "/create/create-season-registration",
        element: <CreateLeagueRegistrationPage />,
      },

    ]
  },
  {
    // The step-by-step registration wizard is retired — legacy URLs redirect to
    // the create dialog / sectioned edit page (see LegacyWizardRedirect).
    path: "/create-registration",
    element: <OrganizationLayout />,
    children: [
      {
        path: "/create-registration/:contestType/:step",
        element: <LegacyWizardRedirect />,
      },
      {
        path: "/create-registration",
        element: <LegacyWizardRedirect />,
      },
    ]
  },
  {
    path: '/admin',
    element: <OrganizationLayout />,
    children: [
      { path: '/admin', element: <LoginPage />, exact: true },
      { path: "/admin/editor", element: <CanvasEditorAdmin />, exact: true },
      { path: "/admin/dashboard", element: <DashboardAdmin />, exact: true },
      { path: "/admin/get-started", element: <GetStartedAdmin />, exact: true },

      // User Admin
      { path: '/admin/members', element: <MemberAdmin />, exact: true },

      // User Admin
      { path: '/admin/locations', element: <LocationAdmin />, exact: true },

      // League Admin
      {
        path: "/admin/league",
        element: props => <Redirect to={`/admin/league/seasons`} />,
        exact: true
      },
      { path: '/admin/transactions', element: <TransactionAdmin />, exact: true },
      { path: '/admin/waivers', element: <WaiverAdmin />, exact: true },
      // { path: "/admin/league/season/:seasonId/divisions", element: <DivisionAdmin />, exact: true },
      // { path: '/admin/league/season/:seasonId/division/:divisionId/teams', element: <TeamAdmin />, exact: true },
      // { path: '/admin/league/season/:seasonId/division/:divisionId/games', element: <GameAdmin />, exact: true },
      // New organization routes
      // ResourceOrgGuard (INT-0036): id-routed pages verify the resource
      // belongs to the ACTIVE org before mounting — otherwise a proper
      // access-denied/not-found page renders instead of a foreign resource
      // under this org's chrome. New id-routed admin routes must be wrapped
      // the same way.
      { path: '/admin/organization/league/:leagueId/divisions/schedule', element: <ResourceOrgGuard resource="league" param="leagueId"><DivisionSchedule /></ResourceOrgGuard>, exact: true },
      { path: '/admin/organization/league/:leagueId/division/:divisionId/game/:gameId/stats', element: <ResourceOrgGuard resource="division" param="divisionId"><StatAdmin /></ResourceOrgGuard>, exact: true },

      { path: '/admin/organization/tournament/:tournamentId/contest/:leagueId/divisions/schedule', element: <ResourceOrgGuard resource="tournament" param="tournamentId"><DivisionSchedule /></ResourceOrgGuard>, exact: true },
      { path: '/admin/organization/tournament/:tournamentId/contest/:leagueId/division/:divisionId/game/:gameId/stats', element: <ResourceOrgGuard resource="division" param="divisionId"><StatAdmin /></ResourceOrgGuard>, exact: true },

      { path: '/admin/organization/scheduler/:leagueId', element: <ResourceOrgGuard resource="league" param="leagueId"><SchedulerAdmin /></ResourceOrgGuard>, exact: true },

      // Redirects from old routes
      { path: '/admin/league/season/:seasonId/*', element: <RedirectLeagueRoute /> },
      { path: '/admin/league/tournament/:tournamentId/contest/:seasonId/*', element: <RedirectTournamentRoute /> },
      { path: '/admin/scheduler/season/:seasonId', element: <RedirectSchedulerRoute /> },

      // Tournament Admin
      { path: '/admin/tournament/editor', element: <CanvasEditorAdmin />, exact: true },
      {
        path: '/admin/tournament',
        element: props => <Redirect to={`/admin/tournament/seasons`} />,
        exact: true
      },

      { path: '/admin/organize', element: <OrganizeAdmin />, exact: true },
      { path: '/admin/game-results', element: <UpcomingGamesAdmin />, exact: true },

      { path: '/admin/settings', element: <SettingAdmin />, exact: true },
      { path: '/admin/appearance', element: <AppearanceAdmin />, exact: true },
      // The legacy Tournaments/Leagues/Contests/Divisions/Teams/Players/Games
      // grids, the v1 tournament scheduler (/admin/scheduler-day/), and the
      // Pricing page (/admin/payment-products) were DELETED 2026-08-26 — the
      // Competitions tab, DivisionPage, the Day2 scheduler, and the
      // registration Payments pane are the canonical surfaces. Never re-add.
      { path: '/admin/logs', element: <LogsAdmin />, exact: true },
      { path: '/admin/email-templates', element: <EmailTemplateAdmin />, exact: true },
      { path: '/admin/email-templates/:templateKey', element: <EmailTemplateEditor />, exact: true },
      { path: '/admin/messages', element: <BroadcastAdmin />, exact: true },
      { path: '/admin/messages/new', element: <BroadcastCompose />, exact: true },
      { path: '/admin/stripe-replay', element: <ReplayWebhooks />, exact: true },
      { path: '/admin/admin-logs2', element: <AdminUsageAdmin />, exact: true },
      // INTERNAL/UNLISTED impersonation tool — reachable by URL only, never in the sidebar or docs.
      { path: '/admin/impersonate2', element: <ImpersonateAdmin />, exact: true },

      // Scheduler Admin (old route redirects above, new route above)
      { path: '/admin/scheduler', element: <SchedulerListAdmin />, exact: true },

      // Tournament Scheduler Admin
      { path: '/admin/scheduler-day2/tournament/:tournamentId', element: <ResourceOrgGuard resource="tournament" param="tournamentId"><TournamentSchedulerDay2Admin /></ResourceOrgGuard>, exact: true },
      { path: '/admin/scheduler-day2/tournament/:tournamentId/bulk-import', element: <ResourceOrgGuard resource="tournament" param="tournamentId"><TournamentBulkImportGames /></ResourceOrgGuard>, exact: true },
      { path: '/admin/division/:divisionId', element: <ResourceOrgGuard resource="division" param="divisionId"><DivisionPage /></ResourceOrgGuard>, exact: true },
      // KNOWN GAP (INT-0036): no GET /games/:id exists to resolve this
      // game's org — unguarded until a games show endpoint lands.
      { path: '/admin/game/:gameId/stats', element: <StatAdmin />, exact: true },
      { path: '/admin/team/:teamId', element: <ResourceOrgGuard resource="divisionTeam" param="teamId"><TeamDetailPage /></ResourceOrgGuard>, exact: true },
      
      // Registration Admin
      { path: '/admin/registration', element: <RegistrationListAdmin />, exact: true },
      { path: '/admin/registration/:registrationId', element: <ResourceOrgGuard resource="registration" param="registrationId"><RegistrationAdmin /></ResourceOrgGuard>, exact: true },
      { path: '/admin/registration/:registrationId/edit', element: <ResourceOrgGuard resource="registration" param="registrationId"><RegistrationEditPage /></ResourceOrgGuard>, exact: true },
      { path: '/admin/registration/:registrationId/teams', element: <ResourceOrgGuard resource="registration" param="registrationId"><RegistrationTeamAdmin /></ResourceOrgGuard>, exact: true },
      { 
        path: "/admin/create-app",
        element: <CreateApp />
      },


      // { 
      //   path: '/admin/league', 
      //   element: <OrganizationLayout />,
      //   children: [
      //     // { path: "/:leagueName/admin/league/editor", element: <HomeEditorAdmin />, exact: true },
      //     {
      //       path: "/admin/league",
      //       element: props => <Redirect to={`/admin/league/seasons`} />,
      //       exact: true
      //     },
      //     { path: "/admin/league/leagues", element: <LeagueAdmin />, exact: true },
      //     { path: "/admin/league/season/:seasonId/divisions", element: <DivisionAdmin />, exact: true },
      //     { path: '/admin/league/season/:seasonId/division/:divisionId/teams', element: <TeamAdmin />, exact: true },
      //     { path: '/admin/league/season/:seasonId/division/:divisionId/games', element: <GameAdmin />, exact: true },
      //     { path: '/admin/league/season/:seasonId/division/:divisionId/team/:teamId/players', element: <PlayerAdmin />, exact: true },
      //   ]
      // },
      // {
      //   path: '/admin/tournament',
      //   element: <OrganizationLayout />,
      //   children: [
      //     { path: '/admin/tournament/editor', element: <CanvasEditorAdmin />, exact: true },
      //     {
      //       path: '/admin/tournament',
      //       element: props => <Redirect to={`/admin/tournament/seasons`} />,
      //       exact: true
      //     },
      //     { path: '/admin/tournament/seasons', element: <LeagueAdmin />, exact: true },
      //     { path: '/admin/tournament/season/:seasonId/divisions', element: <DivisionAdmin />, exact: true },
      //     { path: '/admin/tournament/season/:seasonId/division/:divisionId/teams', element: <TeamAdmin />, exact: true },
      //     { path: '/admin/tournament/season/:seasonId/division/:divisionId/games', element: <GameAdmin />, exact: true },
      //     { path: '/admin/tournament/season/:seasonId/division/:divisionId/team/:teamId/players', element: <PlayerAdmin />, exact: true },
      //   ]
      // },
      // {
      //   path: '/admin/registration',
      //   element: <OrganizationLayout />,
      //   children: [
      //     { path: '/admin/registration', element: <RegistrationListAdmin />, exact: true },
      //     { path: '/admin/registration/:registrationId', element: <RegistrationAdmin />, exact: true },
      //   ]
      // }
    ]
  },
  ],
  },
]);

export default routes;
